// Meta Pixel helper — Pixel ID: 1283250386981385

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: unknown
  }
}

export function initPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  // Inject fbq stub
  const n: any = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Init & PageView
  window.fbq('init', '1283250386981385')
  window.fbq('track', 'PageView')

  // Noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1283250386981385&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.head.appendChild(noscript)
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Rutina Antiarrugas 40+ en 7 Días — Exosome Express',
      content_ids: ['52895245762903'],
      content_type: 'product',
      value: 6.39,
      currency: 'EUR',
    })
  }
}
